import React, { useEffect, useState } from "react";
import { globalImport } from "../../../common/globalImports";
import { Network } from "../../../utils/network";
import ContestClosedCard from "./ClosedDetailCard";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  SafeAreaView,
  Platform,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import Colors from "../../../assets/Color/Colors";
import NoMarket from "../../../commonComponents/NoMarkets";

const ClosedContest = ({ contestId }) => {
  const [contestClosedDetails, setContestClosedDetails] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const renderFantasyCard = ({ item, index }) => {
    return (
      <View key={index}>
        <ContestClosedCard contestDetails={item} />
      </View>
    );
  };

  useEffect(() => {
    getClosedDetails();
  }, []);

  const getClosedDetails = async () => {
    setLoading(true);
    const res = await Network.getContestClosedDetails(contestId);
    if (res?.data?.success) {
      setContestClosedDetails(res?.data?.events);
    }
    setLoading(false);
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {isLoading ? (
          <ActivityIndicator size="large" color={Colors.black} />
        ) : null}
      </View>
    );
  };

  const handleEmpty = () => {
    return <NoMarket innerContestCondition={true} source={"contest_closed"} />;
  };

  return (
    <View style={{ marginTop: -15 }}>
      <FlatList
        contentContainerStyle={{
          paddingBottom: contestClosedDetails.length === 0 ? 0 : 350,
        }}
        //columnWrapperStyle={{ flex: 1 }}
        data={contestClosedDetails}
        ListEmptyComponent={handleEmpty}
        renderItem={renderFantasyCard}
        onRefresh={getClosedDetails}
        refreshing={isLoading}
        keyExtractor={(item, index) => item.id}
        showsVerticalScrollIndicator={false}
        initialNumToRender={10}
        updateCellsBatchingPeriod={15}
        ListFooterComponent={globalImport.isWeb ? renderFooter : <></>}
      />
    </View>
  );
};

export default ClosedContest;
